<template>
  <f7-page id="home-page" name="home" @page:beforein="loadCustomerDetails()" @page:beforeout="handleBeforeOut()" @page:afterin="afterin">
    <div class="block">
      <div class="row mb-md">
        <div class="col-85 text-align-left pt-sm">
          <div class="text-color-white mb-sm fs-20 break-text">
            {{$t('general-text-hello')}} <span class="fw-bold">{{ customerAlias.trim().toLowerCase() != "customer" ? customerAlias : ""  }}</span>
            <img :src="require('@/assets/img/icon/hand.svg')" class="d-none"/>
            <span class="ml-md d-none">({{ $store.state.customer.customerId }})</span>
          </div>
        </div>

        <div class="col-15 text-align-right pt-sm mb-sm align-self-center">
          <a class="link" @click="navigateTo('notification')">
            <img :src="require('@/assets/img/icon/icon-notif.svg')" />
            <span v-if="totalUnreadNotif>0" :class=" (totalUnreadNotif >= 10) ? 'icon-notif-number two-digit' : 'icon-notif-number' ">{{ totalUnreadNotif }}</span>
          </a>
        </div>
      </div>

      <f7-swiper class="swiper-notice" pagination navigation :params="{ slidesPerView: 1, spaceBetween: 20}" >
        <f7-swiper-slide v-if="showDefaultSwiper" class="card justify-content-center">
          <!-- <div class="preloader infinite-scroll-preloader"></div> -->
          <div class="swiper-lazy-preloader"></div>
        </f7-swiper-slide>

        <f7-swiper-slide v-for="item in swiperTrxList" :key="item.id" :data-inboxId="item.messageId" :data-type="item.type" class="card justify-content-center">
          <!-- Verify -->
          <div v-if="item.type == 1">
            <div class="b fs-18">{{$t('home-verify-account')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span>{{$t('home-verify-myinfo-text')}}</span>
            </div>
            <f7-button large fill class="mb-sm" @click="navigateTo('verifyMyInfo')"> {{$t('home-btn-verify-myinfo')}} </f7-button>
            <f7-button large outline class="mb-sm" @click="navigateTo('verify')"> {{$t('home-btn-verify-manual')}} </f7-button>
          </div>

          <!-- POA -->
          <div v-if="item.type == 2" class="w-80">
            <div class="b fs-18">{{$t('home-complete-registration')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span>{{$t('home-upload-poa-text')}}</span>
            </div>
            <f7-button large fill class="mb-sm" @click="navigateTo('verifyPOA')"> {{$t('home-btn-poa')}}</f7-button>
          </div>

          <!-- VERIFY EMAIL -->
          <div v-if="item.type == 7" class="w-80">
            <div class="b fs-18">{{$t('home-verify-email')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-lg">
              <p>{{$t('home-verify-email-content')}}</p>
              <p>{{$t(i18nResendModuleEVC)}}</p>
            </div>
            <f7-button v-show="resendEVCModule.showButton" :disabled="!resendEVCModule.enableButton" large fill class="mb-md" @click="handleResendEmailLink()">
              {{$t('home-verify-email-btn-text')}} <span v-show="resendEVCModule.showTimer">( {{ resendEVCModule.timerTime }} )</span>
            </f7-button>
          </div>

          <!-- VERIFY NEW EMAIL -->
            <div v-if="item.type == 10" class="w-80">
            <div class="b fs-18">{{$t('home-verify-update-email')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-lg">
              <p>{{$t('home-verify-update-email-content')}}</p>
              <p>{{$t(i18nResendModuleEVC)}}</p>
            </div>
            <f7-button v-show="resendEVCModule.showButton" :disabled="!resendEVCModule.enableButton" large fill class="mb-md" @click="handleResendEmailLink()">
              {{$t('home-verify-email-btn-text')}} <span v-show="resendEVCModule.showTimer">( {{ resendEVCModule.timerTime }} )</span>
            </f7-button>
          </div>

          <!-- FIRST TRX -->
          <div v-if="item.type == 3" class="w-80">
            <div class="b fs-18">{{$t('home-first-transfer')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <p class="mb-5">{{$t('home-first-transfer-text')}}</p>
              <p class="pointer" @click="navigateTo('IETNC')">{{$t('general-text-tncs-apply')}}</p>
            </div>
          </div>

          <!-- CANCELLED TRX -->
          <div v-if="item.type == 4" class="w-80">
            <div class="b fs-18">{{$t('home-tx-cancel')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span v-if="!multiCancelledTrx" >{{$t('home-tx-cancel-single', {trxId:item.trxId})}}</span>
              <span v-else>{{$t('home-tx-cancel-multiple', {count:countCancelledTrx})}}</span>
            </div>
            <f7-button v-if="!multiCancelledTrx" large fill class="mb-sm" @click="handleSwiperBtnAction('transactionDetail', item.trxId)"> {{$t('home-btn-check-transfer-tx', {trxId:item.trxId})}} </f7-button>
            <f7-button v-else large fill class="mb-sm" @click="eventHandleSwipedByCustomer(); navigateTo('history')"> {{$t('home-btn-check-transfer')}} </f7-button>
          </div>

          <!-- TRX PAYMENT REMINDER -->
          <div v-if="item.type == 5" class="w-80">
            <div class="b fs-18">{{$t('home-payment-reminder')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span >{{$t('home-payment-reminder-text', {name:customerObj.customerAlias, trxId:item.trxId, DATE: item.date})}}</span>
            </div>
            <f7-button large fill class="mb-sm" @click="handleSwiperBtnAction('makePayment', item.trxId)"> {{$t('general-text-make-payment')}} </f7-button>
          </div>

          <!-- UNSUCCESSFUL PAYMENT -->
          <div v-if="item.type == 6" class="w-80">
            <div class="b fs-18">{{$t('home-payment-unsuccess')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span >{{$t('home-payment-unsuccess-text', {name:customerObj.customerAlias, trxId:item.trxId})}}</span>
            </div>
            <f7-button large fill class="mb-sm external" target="_blank" :href="zohoForm"> {{$t('home-refund-swiper-btn-1')}} </f7-button>
          </div>

          <!-- REFUND -->
          <div v-if="item.type == 9" class="w-80 d-none">
            <div class="b fs-18">{{$t('home-refund-swiper-title')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span >{{$t('home-refund-swiper-content-1', {name:customerObj.customerAlias, trxId:item.trxId})}}</span>
            </div>
            <f7-button large fill class="mb-sm external" target="_blank" :href="zohoForm"> {{$t('home-refund-swiper-btn-1')}} </f7-button>
          </div>

          <!-- Birthday -->
          <div  v-if="item.type == 8" class="w-80">
            <div class="b fs-18">{{$t('general-text-birthday')}}</div>
            <div class="fs-14 fw-medium text-color-gray mt-sm mb-xl">
              <span class="d-none">{{$t('home-birthday', {name:customerObj.customerAlias})}}<br/></span>
              <span>{{ $t('home-birthday-text') }}</span>
            </div>
          </div>
        </f7-swiper-slide>
      </f7-swiper>

      <ExchangeRateCalculator class="mt-20 mb-xl" :isHomeView="true" :keepLoading="keepLoading" v-if="loadFxRate" @setIsCountryPopulated="setIsCountryPopulated" />

      <!-- Quick Send -->
      <div v-if="beneficiaryQuickSend.length > 0" class="card">
        <div class="card-header">{{$t('general-text-quick-send')}}</div>
        <div class="card-content pt-0 pb-0">
          <f7-list media-list no-hairlines class="beneficiary-list quick-bene-list">
            <f7-list-item v-for="bene in beneficiaryQuickSend" :key="bene.beneficiaryId" @click="selectBeneficiary(bene.beneficiaryId)" class="pt-20 pb-20">
              <f7-row no-gap class="list-content-row">
                <f7-col class="col-media">
                  <img :src="require('@/assets/img/flags/flag_circle_small_'+bene.homeCountryId+'.png')" />
                </f7-col>
                <f7-col class="col-details">
                  <div class="fw-bold fs-14">{{bene.firstName}}</div>
                  <div class="fs-12 fw-medium text-color-gray" v-if="bene.deliveryMethodId == 1 || bene.deliveryMethodId == 6 || bene.deliveryMethodId == 9">{{bene.bank}}&nbsp;&colon;&nbsp;{{bene.bankAccountNo}}</div>
                  <div class="fs-12 fw-medium text-color-gray" v-if="bene.deliveryMethodId == 3">{{bene.collectionAgent}}</div>
                  <div class="fs-12 fw-medium text-color-gray" v-if="bene.deliveryMethodId == 4">{{bene.address.province}}&nbsp;&colon;&nbsp;{{bene.address.city}}</div>
                  <div class="fs-12 fw-medium text-color-gray" v-if="bene.deliveryMethodId == 0">{{bene.billingOrg}}&nbsp;&colon;&nbsp;{{bene.bankAccountNo}}</div>
                </f7-col>
                <f7-col class="text-align-right col-button">
                  <f7-button outline class="quick-send">{{$t('general-text-send')}}</f7-button>
                </f7-col>
              </f7-row>
            </f7-list-item>
          </f7-list>
        </div>
      </div>

      <!-- INVITE AND EARN -->
      <div class="card pointer mt-20" @click="navigateTo('inviteearn')">
        <div class="card-content card-content-padding display-flex align-items-center">
          <div class="padding bg-color-theme-color-10 border-100">
            <img :src="require('@/assets/img/icon/invite-earn.png')" style="width: 28px; height:28px"/>
          </div>
          <div class="padding-left">
            <span class="b fs-16 fw-medium">{{$t('home-invite-coupon', {amount:couponAmount, name:couponAmount})}} </span><br/>
            <span class="b fs-12 text-color-primary">{{$t('general-text-invite-now')}}</span><br/>
            <span class="text-color-gray">{{$t('general-text-tncs-apply')}}</span>
          </div>
        </div>
      </div>

    </div>
    <!-- end of page-content -->

    <f7-toolbar bottom no-hairline class="toolbar-mobile-menu view-mobile elevation-10">
      <f7-tabs>
        <f7-link id="tab-1" tab-link @click="navigateTo('home')">
          <img :src="require('@/assets/img/icon/icon-home.svg')" />
          <div class="tabbar-label">{{$t('general-text-home')}}</div>
        </f7-link>
        <f7-link id="tab-2" tab-link @click="navigateTo('history')">
          <img :src="require('@/assets/img/icon/icon-activities.svg')" />
          <div class="tabbar-label">{{$t('general-text-activities')}}</div>
        </f7-link>
        <f7-link id="tab-0" tab-link style="position: relative;" @click="navigateTo('sendmoney')" >
          <div style="position: absolute; bottom: 0; width: 100%;">
            <img :src="require('@/assets/img/icon/icon-send.svg')" class="elevation-5" style="border-radius: 50%;" />
            <div>{{$t('general-text-send')}}</div>
          </div>
        </f7-link>
        <f7-link id="tab-3" tab-link @click="navigateTo('beneficiary-list')">
          <img :src="require('@/assets/img/icon/icon-recipients.svg')" />
          <div class="tabbar-label">{{$t('general-text-recipients')}}</div>
        </f7-link>
        <f7-link id="tab-4" tab-link @click="navigateTo('account')">
          <img :src="require('@/assets/img/icon/icon-account.svg')" />
          <div class="tabbar-label">{{$t('general-text-me')}}</div>
        </f7-link>
      </f7-tabs>
    </f7-toolbar>
  </f7-page>
</template>

<script>

  // import ExchangeRateCalculator from '@/components/exchange-rate-calculator'
  import { mapGetters, mapActions } from "vuex"
  import { check, dateHelper } from '@/plugins/helper';

  export default {
    components: {
      ExchangeRateCalculator      : () => import('../components/exchange-rate-calculator.vue'),
    },

    async mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.zohoForm = process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK

      this.resendEVCModule = this.$store.state.misc.resendEVCModule
      if(this.resendEVCModule.timerTime || this.resendEVCModule.attemptCount == 3){
        this.resendEVCCountDownTimer()
      }

      const countryPromise = await this.$api.beneficiary.getCountryPhoneCodeList();
      this.setCountryCodeList(countryPromise);
    },

    data() {
      return {
        beneficiaryQuickSend  : [],
        customerObj           : { customerName : "", customerAlias : "", customerId  : "", },
        defaultMaxSwiper      : 5,
        showDefaultSwiper     : true,
        isPopulatingSwiper    : false,
        swiperTrxList         : [],
        multiCancelledTrx     : false,
        countCancelledTrx     : 0,
        countUnreadInbox      : 0,
        couponAmount          : 20,
        hasNoTrx              : false,
        myInfoWindow          : undefined,
        myInfoTimer           : null,
        i18nResendModuleEVC   : "home-verify-email-content-1",
        timeoutResendEVC      : null,
        resendEVCModule: {
          timerTime           : 30,
          showTimer           : false,
          enableButton        : true,
          showButton          : true,
          attemptCount        : 0,
          time15Minutes       : '',
        },
        zohoForm              : '',
        loadFxRate            : false,
        keepLoading           : false,
        isCountryPopulated    : false,
        totalUnreadNotif      : 0,
      };
    },

    watch: {
      isPopulatingSwiper(newValue) {
        console.log("watch isPopulatingSwiper " + newValue)
        if (!newValue && this.isCountryPopulated) {
          this.hideLoading()
          console.log("isPopulatingSwiper hidePreloader")
        }
      },

      isCountryPopulated(newValue){
        if (newValue && !this.isPopulatingSwiper) {
          this.hideLoading()
          console.log("countryPopulated hidePreloader")
        }
      }
    },

    destroyed() {
      if (window.updateAccountMyInfoCallback) window.updateAccountMyInfoCallback = null;
    },
		computed: {
			...mapGetters('misc', ['redirectAfterLogin']),
      ...mapGetters('customer', ['customerAlias']),
      ...mapGetters('registration', ['isAxsr']),
		},
    methods: {
      ...mapActions('transaction', [ 'setTransactionDetail' ]),
      ...mapActions('myinfo', [
          'setAddress',
          'setDob',
          'setEmail',
          'setEmployerName',
          'setEmploymentSector',
          'setFullname',
          'setGender',
          'setIdentificationNo',
          'setNationality',
          'setOccupation',
          'setPassExpiryDate',
          'setPassStatus',
          'setPassType',
          'setResidentialStatus',
          'setEnabledField',
          'setMyInfoState',
          'setMyInfoCode',
          'setOccupationList',
          'setNationalityList',
          'setRouterTo',
      ]),
			...mapActions('misc', ['setRedirectAfterLogin']),
      ...mapActions('beneficiary', ['setCountryCodeList']),
      ...mapActions('customer', ['setLatestTx', 'setTxDestList']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      hideLoading(){
        this.showDefaultSwiper = false;
        this.keepLoading = false;
        this.hidePreloader();
      },

      loadCustomerDetails() {
        console.log("LOAD CUSTOMER DETAILS");
        const self = this;

        console.log("Home page, AXS ? "+self.isAxsr)

        //self.loadFxRate = true
        self.keepLoading = true
        self.isPopulatingSwiper = true
        self.showPreloader();
        const swiperNotice = document.querySelector('.swiper-notice').swiper
        swiperNotice.on('slideChange', function(){
          self.eventHandleSwipedByCustomer()
        });

        self.getDiscountDetail()
        if(!this.$api.customer.getSessionId()) {
          this.$api.customer.generateSessionId();
        }

        const customerPromise           = this.$api.customer.getCustomerDetails();
        const custBeneficiaryQuickSend  = this.$api.customer.getBeneficiaryQuickSend(3);
        const getTrxListPromise         = this.$api.transaction.getMyTransactionList(0, 1, '');
        const getInboxMsgsPromise       = this.$api.customer.getInboxMessage(0, 0, 0);
        const getUnreadNotification       = this.$api.customer.getUnreadNotification();
        const getTrxListPromise10         = this.$api.transaction.getMyTransactionList(0, 10, '');
        Promise.all([customerPromise, custBeneficiaryQuickSend, getTrxListPromise, getInboxMsgsPromise, getUnreadNotification, getTrxListPromise10]).then((response)=>{
          const custDetails = response[0];
          const custBeneQuickSendList = response[1]
          const trxList = response[2]
          const inboxList = response[3]
          const unreadMessageList = response[4]
          const trxList10 = response[5]

          /* WA-396 */
          self.setLatestTx(trxList[0]);
          self.loadFxRate = true // render calculator after got the tx list

          // GET DEST COUNTRY LIST
          let arrTempCountryId = [... new Set(trxList10.map(x=>x.homeCountryId))];
          self.setTxDestList(arrTempCountryId)
          console.log("arrTempCountryId: ", arrTempCountryId)
          /* END OF WA-396 */

          self.totalUnreadNotif= unreadMessageList.count_unread
          self.hasNoTrx = ( trxList != undefined && trxList.length > 0 ) ? false : true
          self.customerObj = custDetails;
          self.beneficiaryQuickSend = custBeneQuickSendList;
          self.handleRedirectAfterLogin();
          self.saveCustomerDetails(custDetails, inboxList);

          // this.hidePreloader();
          // self.keepLoading = false

          this.setZohoChatbotCustomer();
          this.registerDeviceTokenCustomer(this.$store.state.customer.customerId);
        }).catch((error) => {
          console.error(error);
          this.this.hideLoading()
        });
      },

      async saveCustomerDetails(customerResult, inboxList){
        console.log("customerResult", customerResult)
        var customer = this.$store.state.customer;
        customer.customerName = customerResult.customerName;
        customer.customerAlias = customerResult.customerAlias;
        customer.customerId = customerResult.customerId;
        customer.gender = customerResult.gender;
        customer.corporate = customerResult.corporate;
        customer.vip = customerResult.vip;
        customer.dob = customerResult.dob;
        customer.dateCreated = customerResult.dateCreated;
        customer.email = customerResult.email;
        customer.newEmail = customerResult.newEmail;
        customer.emailverified = customerResult.emailverified;
        customer.postalCode = customerResult.postalCode;
        customer.mobile = customerResult.mobile;
        customer.mobileCountryId = customerResult.mobileCountryId;
        customer.mobileCountryCode = customerResult.mobileCountryCode;
        customer.nationalityId = customerResult.nationalityId;
        customer.nationality = customerResult.nationality;
        customer.statusId = customerResult.statusId;
        customer.regRetailAgentId = customerResult.regRetailAgentId;
        customer.regRetailBranchId = customerResult.regRetailBranchId;
        customer.isPOA = customerResult.isPOA;
        customer.minOutstandingAmt = customerResult.minOutstandingAmt;
        customer.maxOutstandingAmt = customerResult.maxOutstandingAmt;
        customer.totalUnclearAmount = customerResult.totalUnclearAmount;
        customer.treasuryReceiptAmountLimit = customerResult.treasuryReceiptAmountLimit;
        customer.onlineTreasuryReceiptAmountLimit = customerResult.onlineTreasuryReceiptAmountLimit;
        customer.storedValue = customerResult.storedValue;
        customer.lastAcceptedTncVersion = customerResult.lastAcceptedTncVersion;
        customer.qrCode = customerResult.qrCode;
        customer.occupation = customerResult.occupation;
        customer.numOfBeneficiary = customerResult.numOfBeneficiary;
        customer.eKYCDoc = customerResult.eKYCDoc;
        customer.eKYCDocStatus = customerResult.eKYCDocStatus;
        customer.eKYCPOAStatus = customerResult.eKYCPoaStatus;
        customer.eKYCSelfieStatus = customerResult.eKYCSelfie;
        customer.customerDocumentList = customerResult.customerDocumentList;
        customer.svStatusId = customerResult.svStatusId;
        customer.inactiveWallet = customerResult.inactiveWallet;
        customer.sourceRemittance = customerResult.sourceRemittance;
        customer.paymentEKYC = false;
        customer.evcExpiryDate = customerResult.evcExpiryDate;
        customer.lastFxCalcCurrencyId = customerResult.lastFxCalcCurrencyId;        

        this.customerObj = this.$store.state.customer;

        await this.populateSwiperItems(inboxList);
        this.isPopulatingSwiper = false
        // this.setZohoChatbotCustomer();
        // this.registerDeviceTokenCustomer(customer.customerId);
      },

      handleRedirectAfterLogin(){
        // this.showPreloader();
        if(this.redirectAfterLogin[1] > 0 ){
          const redirLife = (Date.now() - this.redirectAfterLogin[1]) / 1000 / 60
          if( redirLife <= 15 ){
            const redirPath = this.redirectAfterLogin[0]
            this.setRedirectAfterLogin(["", 0])
            this.$store.state.beneficiary.routerTo = '' // CL: Copied from navigateTo(page). Don't know why this is required.
            // this.hidePreloader();
            this.$f7router.navigate(redirPath, { transition: 'f7-push'});
          } else { this.setRedirectAfterLogin(["", 0]);
            // this.hidePreloader();
          }
        } else {
          // this.hidePreloader();
        }
      },

      navigateTo(page){
        this.$store.state.beneficiary.routerTo = ''
        if(page=='sendmoney'){
          this.$store.state.beneficiary.routerTo = "home"
          this.$f7router.navigate("/sendmoney/select-beneficiary"  , { transition: 'f7-push'});
        }else if(page == 'account'){
          this.$f7router.navigate("/account"                       , { transition: 'f7-push'});
        }else if(page == 'fxcalculator'){
          this.$f7router.navigate("/rate"                          , { transition: 'f7-push'});
        }else if(page == 'beneficiary-list'){
          this.$store.state.beneficiary.routerTo = "home"
          this.$f7router.navigate("/beneficiary-list"              , { transition: 'f7-push'});
        }else if(page == 'verify'){
          this.$f7router.navigate('/verify/type-list'              , { props: { isFromHome: true }});
        }else if(page == 'verifyPOA'){
          this.$f7router.navigate("/verify/take-photo"             , { props: { doc: {id: 17, name: 'POA'} }});
        }else if(page == 'history'){
          this.$f7router.navigate("/transaction-history"           , { transition: 'f7-push'});
        }else if(page == 'notification'){
          this.$store.state.customer.routerTo = "home"
          this.$f7router.navigate("/notification"                  , { transition: 'f7-push'});
        } else if(page == 'contactus'){
         // this.$f7router.navigate("/contact-us"           , { transition: 'f7-push'});
        }else if(page == 'verifyMyInfo'){
          this.getMyInfoUrl();
        }else if(page == 'inviteearn'){
          this.$f7router.navigate("/account/invite-earn"           , { transition: 'f7-push'});
        }else if(page == 'IETNC'){
          this.$f7router.navigate("/invite-earn-tnc"           , { transition: 'f7-push'});
        }
      },

      selectBeneficiary(id){
        this.showPreloader();
        var selectedBeneData = this.beneficiaryQuickSend.filter(function (el) {
          return el.beneficiaryId == id;
        });

        var beneficiaryData                  = this.$store.state.beneficiary
        beneficiaryData.statusId             = selectedBeneData[0].statusId

        var transactionData                  = this.$store.state.transaction;
        transactionData.beneficiaryId        = id;
        transactionData.beneficiaryFirstName = selectedBeneData[0].firstName;
        transactionData.beneficiaryAlias     = selectedBeneData[0].beneficiaryAlias;
        transactionData.beneficiaryFullName  = selectedBeneData[0].fullName;
        transactionData.p2hCustomerId        = selectedBeneData[0].p2hCustomerId;
        transactionData.bankAccountNo        = selectedBeneData[0].bankAccountNo;
        transactionData.bankId               = selectedBeneData[0].bankId;
        transactionData.bankName             = selectedBeneData[0].bank;
        transactionData.homeCountryId        = selectedBeneData[0].homeCountryId;
        transactionData.homeCountryName      = selectedBeneData[0].address.country;
        transactionData.homeCurrency         = selectedBeneData[0].homeCurrency;
        transactionData.hostCountryId        = selectedBeneData[0].originatingCountryId;
        transactionData.hostCountryName      = selectedBeneData[0].originatingCountry;
        transactionData.hostCurrency         = selectedBeneData[0].hostCurrency;
        transactionData.deliveryMethodId     = selectedBeneData[0].deliveryMethodId;
        transactionData.deliveryMethodName   = selectedBeneData[0].deliveryMethod;
        transactionData.collectionAgentId    = selectedBeneData[0].collectionAgentId;
        transactionData.collectionAgent      = selectedBeneData[0].collectionAgent;
        transactionData.transactionTypeId    = selectedBeneData[0].transactionTypeId;
        transactionData.transactionType      = selectedBeneData[0].transactionType;
        transactionData.billerCode           = selectedBeneData[0].billerCode;
        transactionData.billingOrg           = selectedBeneData[0].billingOrg;
        transactionData.hostAmount           = "";
        transactionData.homeAmount           = "";
        transactionData.hostAmountReal       = 0;
        transactionData.homeAmountReal       = 0;
        transactionData.latestState          = "";
        transactionData.provinceId           = selectedBeneData[0].address.provinceId;
        transactionData.province             = selectedBeneData[0].address.province;
        transactionData.cityId               = selectedBeneData[0].address.cityId;
        transactionData.city                 = selectedBeneData[0].address.city;
        transactionData.couponCode           = "";
        transactionData.paymentPurpose       = selectedBeneData[0].paymentPurpose;
        transactionData.paymentPurposeId     = selectedBeneData[0].paymentPurposeId;
        transactionData.paymentMethodId      = 0;
        transactionData.paymentMethod        = "";
        transactionData.isQuickSend          = true;
        transactionData.isMakePayment        = false;
        transactionData.serviceId            = selectedBeneData[0].serviceId

        // IS PHILGOV ?
        if(transactionData.bankId == 4520 || transactionData.bankId == 4521 || transactionData.bankId == 4522 ){
          var currentDate = new Date()
          transactionData.endMonth       = currentDate.getMonth()
          transactionData.endYear        = null
          transactionData.flexiFund      = null
          transactionData.loanNumber     = ''
          transactionData.mp2            = ''
          transactionData.prn            = ''
          transactionData.startMonth     = currentDate.getMonth()
          transactionData.startYear      = null
          transactionData.monthlyAmount  = null
          transactionData.homeAmountReal = null
          transactionData.bankBranchId   = 0
          this.$f7router.navigate("/sendmoney/choose-transaction-type")
        }else{
          this.$f7router.navigate("/sendmoney/enter-amount")
        }

        this.hidePreloader();
      },

      async populateSwiperItems(inboxList){
        console.log("populateSwiperItems start")
        // 1= verify 2=poa 3=firstTrx 4=cancelledTrx 5=trxPayReminder 6=unsuccessfulTrx 7=verifyemail 8=birthday 9 =refund
        const self               = this
        // self.isPopulatingSwiper = true
        let trxIdsCanceled       = ""
        let cancelledMessageIds  = []
        self.swiperTrxList       = []
        const isMyBirthday       = self.isTodayMyBirthday()

        if(self.isNeedVerify()){
          self.swiperTrxList.push({type: 1, id: 'swiper-verify'})
        } else if(self.isEkycNeedPOA()){
          self.swiperTrxList.push({type: 2, id: 'swiper-poa'});
        }

        let changeEmail = false
        const evcExpiry = new Date(self.customerObj.evcExpiryDate)
        if (!this.$_.isEmpty(self.customerObj.newEmail)) {
          const now = new Date()
          if (evcExpiry.getTime() >= now.getTime()) {
            changeEmail = true
          }
        }

        if(!self.customerObj.emailverified || changeEmail){
          if (changeEmail) {
            self.swiperTrxList.push({type: 10, id: 'swiper-verify-email'})
          } else {
            self.swiperTrxList.push({type: 7, id: 'swiper-verify-email'})
          }

          if(self.resendEVCModule.attemptCount < 3){
            self.i18nResendModuleEVC = "home-verify-email-content-1"
            self.resendEVCModule.showButton = true
          }else{
            self.i18nResendModuleEVC = "home-verify-email-content-2"
            self.resendEVCModule.showButton = false
          }

          self.resendEVCModule.enableButton = (self.resendEVCModule.attemptCount == 3) ? false : true
        }

        const moment= require('moment');
        const today = moment().format('YYYY-MM-DD');
        const maxDate = moment(new Date(self.customerObj.dateCreated)).add(30, 'days').format('YYYY-MM-DD');
        const isMorethan30Days = today > maxDate ? true : false
        //console.log(accountDateCreated+" ## "+maxDate+" ## "+today)
        //console.log("isMorethan30Days : "+isMorethan30Days)

        if( ( self.customerObj.statusId == process.env.VUE_APP_CUSTOMER_STATUS_PROVEN || self.customerObj.statusId == process.env.VUE_APP_CUSTOMER_STATUS_UNPROVEN ) && self.hasNoTrx && !isMorethan30Days){
          self.swiperTrxList.push({type: 3, id: 'swiper-firstTrx', messageId: undefined})
        }

        self.countUnreadInbox = inboxList.length;
        var maxCounter = ( inboxList.length > (self.defaultMaxSwiper-1) ) ? (self.defaultMaxSwiper-1) : ( (inboxList.length-1)) // -1 array list start from 0
        for(let i= maxCounter ; (i >= 0); i--) {
          let id      = inboxList[i].subject.replace(/[^\d]/g, '')
          let content = inboxList[i].content

          if(content.includes('has been cancelled as we have not received your payment') && !inboxList[i].read ){
            self.countCancelledTrx++
            self.multiCancelledTrx = (self.countCancelledTrx > 1) ? true: false
            trxIdsCanceled = (trxIdsCanceled.length > 0) ? trxIdsCanceled + ", "+ id : id
            cancelledMessageIds.push(inboxList[i].id)

            if(self.multiCancelledTrx){
              const index = (self.swiperTrxList).findIndex((item) => item.id === 'swiper-singleCancelledTrx')
              self.swiperTrxList.splice(index, 1);
              self.swiperTrxList.push({type: 4, id: 'swiper-multiCancelledTrx-' + inboxList[i].id, messageId: cancelledMessageIds, trxId : trxIdsCanceled})
            }else{
              self.swiperTrxList.push({type: 4, id: 'swiper-singleCancelledTrx', messageId: cancelledMessageIds, trxId : id})
            }

          }else if(content.includes('Please make the payment')){
            let dateCreated = new Date(inboxList[i].dateCreatedString)
            console.log("isValidDate " + check.isValidDate(dateCreated))
            if (!check.isValidDate(dateCreated)) {
              dateCreated = new Date(inboxList[i].dateCreatedString.replace(/-/g, "/"))
            }
            let createdDate       = dateCreated
            let differentDays     = 0
            let mustPayDateBefore = dateCreated
            let payBeforeDate     = dateCreated

            payBeforeDate.setHours(11)
            payBeforeDate.setMinutes(0)
            payBeforeDate.setSeconds(0)

            if(createdDate.getHours() >= 11){
              payBeforeDate.setDate(payBeforeDate.getDate()+1)
              mustPayDateBefore = payBeforeDate
            }

            differentDays = (new Date() - payBeforeDate)/ (1000 * 60 * 60 * 24)

            let trxFound = self.swiperTrxList.filter(element => { return (element.trxId == id && (element.type==4 || element.type==6) ); })
            if(trxFound.length == 0 && differentDays <= 0){
              const result = await self.$api.transaction.getMyTransactionDetails(id)
              // transactionDetail.then(function(result) {
                if(result.length > 0 && result[0].deliveryStatusId == 10 && result[0].agentPaymentStatusId == 5){
                  self.swiperTrxList.push({
                    type      : 5,
                    id        : 'swiper-trxPayReminder-'+inboxList[i].id,
                    messageId : inboxList[i].id,
                    trxId     : id,
                    date      : mustPayDateBefore.getDate() + " " + self.$t("month-"+mustPayDateBefore.getMonth()+"-mmm" ) + " " +mustPayDateBefore.getFullYear()})
                }
              // })
            }

          }else if(content.includes('has not been successful')){
            const result = await self.$api.transaction.getMyTransactionDetails(id)
            // transactionDetail.then(function(result) {
              if(result != undefined && result.length > 0 && result[0].deliveryStatusId == 50){
                self.swiperTrxList.push({type: 6, id: 'swiper-unsuccessfulTrx-'+inboxList[i].id, messageId: inboxList[i].id, trxId : id})
              }
            // })

          }else if(content.includes('Happy birthday') && isMyBirthday){
            self.swiperTrxList.push({type: 8, id:'swiper-birthday-'+inboxList[i].id, messageId: inboxList[i].id})
          }

        }

        document.querySelector('.swiper-notice').swiper.updateSize()
        // self.isPopulatingSwiper = false
        console.log("populateSwiperItems end")
      },

      isEkycNeedPOA(){
        const self = this
        let result = true

        if(self.customerObj.eKYCPOAStatus == process.env.VUE_APP_EKYC_REVIEW_RECEIVED  || self.customerObj.eKYCPOAStatus == process.env.VUE_APP_EKYC_REVIEW_PENDING ){
          result = false
        }

        return result
      },

      isNeedVerify(){
        const self = this
        let result =  true

        if(self.customerObj.eKYCDocStatus != undefined && self.customerObj.eKYCDocStatus > -1){
          if(self.customerObj.eKYCDocStatus != process.env.VUE_APP_EKYC_REVIEW_NOT_RECEIVED && self.customerObj.eKYCDocStatus != process.env.VUE_APP_EKYC_REVIEW_DOC_INCOMPLETE){
              result = false
          }else{
            result = true
          }
        }else if(self.customerObj.statusId == process.env.VUE_APP_CUSTOMER_STATUS_PROVEN){
          result = false
        }else{
          result = true
        }

        return result
      },

      isTodayMyBirthday(){
        const current    = new Date()
        let myDOB        = new Date(this.customerObj.dob)
        let isMyBirthday =  (myDOB.getMonth() == current.getMonth() && myDOB.getDate() == current.getDate()) ? true : false

        return isMyBirthday
      },

      handleSwiperBtnAction(action, transactionId){
        const self = this
        var transactionData  = self.$store.state.transaction

        if(action == "transactionDetail"){
          self.eventHandleSwipedByCustomer()
          transactionData.transactionId = transactionId
          self.$f7router.navigate("/transaction-history-details", { transition: 'f7-push' })
        }else{
          self.showPreloader()
          const transactionDetail = this.$api.transaction.getMyTransactionDetails(transactionId)
          transactionDetail.then(function(result) {
            const trxDetail                   = result[0]
            var beneficiaryData               = self.$store.state.beneficiary

            beneficiaryData.beneficiaryId     = trxDetail.beneficiaryID
            beneficiaryData.homeCountryId     = trxDetail.homeCountryId
            beneficiaryData.transactionTypeId = trxDetail.transactionTypeId
            beneficiaryData.deliveryMethodId  = trxDetail.deliveryMethodId
            beneficiaryData.bankId            = trxDetail.beneficiaryBankId

            const benePromise = self.$api.beneficiary.getBeneficiaryDetail(beneficiaryData.beneficiaryId, beneficiaryData.transactionTypeId, beneficiaryData.deliveryMethodId, beneficiaryData.bankId)
            benePromise.then(function(result) {
              trxDetail.beneficiaryBankId   = result.bankId
              trxDetail.beneficiaryBank     = result.bank
              trxDetail.paymentPurpose      = result.paymentPurpose
              beneficiaryData.statusId      = result.statusId

              if( trxDetail.deliveryMethodId == 0){
                trxDetail.billerCode   = result.billerCode
              }

              if( trxDetail.deliveryMethodId == 3){
                trxDetail.beneficiaryBank   = result.collectionAgent
                trxDetail.beneficiaryBankId = result.collectionAgentId
              }

              if(action == "updateTransfer"){
                beneficiaryData.isCreateBeneficiary  = false
                self.$f7router.navigate("/beneficiary-modify")
                self.hidePreloader()
              }else if (action == "makePayment"){
                const settlementDetails  = self.$api.settlement.getSettlement(trxDetail.settlementId)
                settlementDetails.then(function(result) {
                  transactionData.totalAmountSettlement  = parseFloat(result.totalAmountPayable) + parseFloat(result.paymentList[0].fee)
                  trxDetail.paymentMethod        = result.paymentList[0].paymentMethod
                  trxDetail.paymentMethodId      = result.paymentList[0].paymentMethodId
                  transactionData.isMakePayment  = true
                  self.setTransactionDetail(trxDetail)
                  self.$f7router.navigate("/sendmoney/payment-detail")
                  self.hidePreloader()
                })
              }
            })
          })
        }
      },

      eventHandleSwipedByCustomer(){
        const swiperNotice   = document.querySelector('.swiper-notice').swiper
        const inboxIdElement = swiperNotice.slides[swiperNotice.activeIndex].dataset.inboxid
        const swiperType = swiperNotice.slides[swiperNotice.activeIndex].dataset.type

        if(inboxIdElement != undefined && inboxIdElement.length > 0 && swiperType== 4){
          const inboxId      = (swiperNotice.slides[swiperNotice.activeIndex].dataset.inboxid).split(",")
          this.$api.customer.updateInboxMessageAsRead(inboxId)
        }
      },

      async getMyInfoUrl() {
        const self = this
        self.showPreloader();
        const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
        const response = await self.$api.customer.getMyInfoUrl(isUsingInAppBrowser);
        if(response && response != undefined && response.value != '') {
            self.setRouterTo('home');
            window.updateAccountMyInfoCallback = self.updateAccountMyInfoCallback;
            if(!isUsingInAppBrowser) {
                self.myInfoTimer = setInterval(function(){ if(self.myInfoWindow.closed) {self.updateAccountMyInfoCallback(false, '', '');} }, 1000);
            }

            if(isUsingInAppBrowser) {
              this.openMyInfoInMobile(response.value);
              this.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                this.updateAccountMyInfoCallback((state != '' && code != ''), state, code);
              });
            } else if(self.myInfoWindow !== undefined) {
              self.myInfoWindow.location.replace(response.value);
            } else {
              self.myInfoWindow = window.open(response.value, '_blank', "fullscreen=1");
            }
        } else {
            self.hidePreloader();
        }
      },

      async updateAccountMyInfoCallback(isSuccess, state, code) {
          window.updateAccountMyInfoCallback = null;
          this.hidePreloader();
          this.setMyInfoState(state);
          this.setMyInfoCode(code);
          this.closePopupOnMobile();
          if(this.myInfoWindow !== undefined) {
              clearInterval(this.myInfoTimer);
              this.myInfoWindow.close();
              this.myInfoWindow = undefined;
          }

          if(isSuccess) {
              this.showPreloader();
              try {
                  const result = await this.$api.registration.getRegisterMyInfoDetail(this.isMyInfoUseInAppBrowser(), code, state);
                  if(result.status == "4854"){
                      const myInfoData = result.result;

                      this.setAddress(myInfoData.address.streetAddress);

                      // FORMAT DOB
                      const dobVal = new Date(myInfoData.dateOfBirth);
                      var formattedToday = '';
                      if(dobVal instanceof Date && !isNaN(dobVal)) {
                        const yyyy = dobVal.getFullYear();
                        let mm = dobVal.getMonth() + 1; // Months start at 0!
                        let dd = dobVal.getDate();

                        if (dd < 10) dd = '0' + dd;
                        if (mm < 10) mm = '0' + mm;

                        formattedToday = dd + '-' + mm + '-' + yyyy;
                      }
                      this.setDob(formattedToday);
                      // END OF FORMAT DOB

                      this.setEmail(myInfoData.email);
                      this.setEmployerName(myInfoData.employer);
                      this.setEmploymentSector(myInfoData.industry);
                      this.setFullname(myInfoData.name);
                      this.setGender(myInfoData.gender);
                      this.setIdentificationNo(myInfoData.identificationNo);
                      this.setNationality({id: myInfoData.nationalityId, name: myInfoData.nationality});
                      this.setOccupation(myInfoData.occupation);
                      this.setPassExpiryDate(dateHelper.formatDateOnly(myInfoData.idExpiryDate));
                      this.setPassStatus(myInfoData.idStatus || "");
                      this.setPassType(myInfoData.identificationType);
                      this.setResidentialStatus({id: myInfoData.residentialStatusId, name: myInfoData.residentialStatus || ""});
                      this.setEnabledField(myInfoData.enabledField);

                      this.$f7router.navigate("/register-myinfo-verify-detail", { props: { isUpdateAccount: true } });
                      this.hidePreloader();
                  }else if(result.status == "0104"){
                      this.alertCard.show = true;
                      this.alertCard.title = "Your ID already exist in our system.";
                      this.alertCard.class = 'alert-danger';
                      this.alertCard.id = 'errorCard';
                      this.hidePreloader();
                  } else {
                      console.log("get details: ERROR -> "+result.status);
                      this.hidePreloader();
                  }
              } catch(e){
                  this.hidePreloader();
                  if(e.message.toLowerCase().includes("undefined")) {
                      this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                  } else {
                      this.$f7.dialog.alert(e.message);
                  }
              }
          }
      },

      getDiscountDetail(){
        const self = this
        const getDiscountDetailPromise = self.$api.customerLoyalty.getDiscountDetail(process.env.VUE_APP_INVITE_EARN_CAMPAIGN_ID)
        getDiscountDetailPromise.then(function(result) {
          self.couponAmount = result[0].feeDiscount
        })
      },

      handleResendEmailLink(){
        const self = this
        self.showPreloader()
        self.resendEVCModule.enableButton = false

        if(self.resendEVCModule.attemptCount >= 3){
          self.hidePreloader()
          return false
        }

        const getCustomerPromise = self.$api.customer.getCustomerDetails()
        getCustomerPromise.then(function(result){
          if(result != undefined && (result.emailverified != undefined && !result.emailverified) || (result.newEmail != undefined && result.newEmail.length > 0)){
            const resendEVCPromise = self.$api.customer.resendEmailVerificationLink(self.customerObj.newEmail)
            resendEVCPromise.then(function(result){
              if(result.status == "WN00113"){
                self.resendEVCModule.attemptCount = self.resendEVCModule.attemptCount + 1
                if(self.resendEVCModule.attemptCount >= 3){
                  const time15Minutes    = new Date()
                  time15Minutes.setMinutes( time15Minutes.getMinutes() + 15 ) // 15 Minutes
                  self.resendEVCModule.time15Minutes  = time15Minutes
                  self.resendEVCModule.showButton = false
                  self.i18nResendModuleEVC = "home-verify-email-content-2"
                }else{
                  self.resendEVCModule.timerTime    = 30 // 30 seconds
                  self.resendEVCModule.showTimer    = true
                  self.resendEVCModule.enableButton = false
                }
                self.$store.state.misc.resendEVCModule = self.resendEVCModule
                self.resendEVCCountDownTimer()
                self.hidePreloader()
              }else{
                self.$f7.dialog.alert( self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
                self.hidePreloader()
              }
            })
          }else{
            if(result.emailverified){
              self.$f7.dialog.alert("Email verified!")
              self.$f7router.navigate( self.$f7router.currentRoute.url, {
                reloadCurrent: true,
                ignoreCache: true,
              });
              self.hidePreloader()
            }else{
              self.hidePreloader()
              self.$f7.dialog.alert( self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            }
          }
        })
      },

      resendEVCCountDownTimer() {
        if(this.resendEVCModule.attemptCount == 3){
          this.timeoutResendEVC = setTimeout(() => {
            const currentDate    = new Date()
            if(currentDate - new Date(this.resendEVCModule.time15Minutes) > 0 ){
              this.resendEVCModule.attemptCount = 0
              this.resendEVCModule.showButton = true
              this.resendEVCModule.enableButton = true
              this.resendEVCModule.showTimer  = false
              this.resendEVCModule.time15Minutes  = ''
              this.i18nResendModuleEVC = "home-verify-email-content-1"
              this.$store.state.misc.resendEVCModule = this.resendEVCModule
            }else{
              this.resendEVCCountDownTimer()
            }
          },10000)
        }else if(this.resendEVCModule.timerTime > 0) {
          this.resendEVCModule.showTimer    = true
          this.resendEVCModule.enableButton = false
          this.timeoutResendEVC = setTimeout(() => {
            this.resendEVCModule.timerTime -= 1
            this.$store.state.misc.resendEVCModule.timerTime = this.resendEVCModule.timerTime
            this.resendEVCCountDownTimer()
          },1000)
        }else{
          this.resendEVCModule.showTimer    = false
          this.resendEVCModule.enableButton = true
          this.$store.state.misc.resendEVCModule = this.resendEVCModule
        }
      },

      handleBeforeOut(){
        clearTimeout(this.timeoutResendEVC)
        this.loadFxRate = false
        this.isCountryPopulated = false
        this.showDefaultSwiper = true
      },

      setIsCountryPopulated(val){
        this.isCountryPopulated = val;
      }
    },
  }
</script>